import styled from '@emotion/styled';

export const NavigationButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  button {
    margin-left: 1.2rem;
  }

  a {
    color: ${({ theme }) => theme.colors.action};
    cursor: pointer;
    margin-right: 1.2rem;
    text-decoration: underline;
    font-weight: bold;

    &:hover {
      color: ${({ theme }) => theme.colors.actionStrong};
    }
  }
`;
